import { cn } from "@/lib/utils";
import {
  MAIL_OUTBOX_STATUS_LABELS,
} from "../mailOutboxPage.constants";
import { getMailOutboxStatusTone } from "../mailOutboxPage.helpers";

interface MailOutboxStatusBadgeProps {
  status: string;
}

export function MailOutboxStatusBadge({ status }: MailOutboxStatusBadgeProps) {
  return (
    <span
      className={cn(
        "rounded border px-2 py-0.5 text-[10.5px] font-semibold",
        getMailOutboxStatusTone(status),
      )}
    >
      {MAIL_OUTBOX_STATUS_LABELS[status] ?? status}
    </span>
  );
}
